'use strict';

module.exports = {
    init: function() {
        if (!String.prototype.endsWith) {
            String.prototype.endsWith = function(searchString, position) { // eslint-disable-line no-extend-native
                var subjectString = this.toString();
                if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
                    position = subjectString.length;
                }
                position -= searchString.length;
                var lastIndex = subjectString.lastIndexOf(searchString, position);
                return lastIndex !== -1 && lastIndex === position;
            };
        }

        (function (ElementProto) {
            if (typeof ElementProto.matches !== 'function') {
                ElementProto.matches = ElementProto.msMatchesSelector || ElementProto.mozMatchesSelector || ElementProto.webkitMatchesSelector || function matches(selector) {
                    var element = this; // eslint-disable-line consistent-this
                    var elements = (element.document || element.ownerDocument).querySelectorAll(selector);
                    var index = 0;

                    while (elements[index] && elements[index] !== element) {
                        ++index;
                    }

                    return Boolean(elements[index]);
                };
            }

            if (typeof ElementProto.closest !== 'function') {
                ElementProto.closest = function closest(selector) {
                    var element = this; // eslint-disable-line consistent-this

                    while (element && element.nodeType === 1) {
                        if (element.matches(selector)) {
                            return element;
                        }

                        element = element.parentNode;
                    }

                    return null;
                };
            }
        })(window.Element.prototype);

        (function () {
            if (typeof window.CustomEvent === "function") { return false; }
        
            var CustomEvent = function CustomEvent(event, params) {
                var evtParams = {
                    bubbles: params.bubbles || false,
                    cancelable: params.cancelable || false,
                    detail: params.detail || undefined
                };
                var evt = document.createEvent('CustomEvent');
                evt.initCustomEvent(event, evtParams.bubbles, evtParams.cancelable, evtParams.detail);
                return evt;
            };
        
            CustomEvent.prototype = window.Event.prototype;
        
            window.CustomEvent = CustomEvent;
        })();
    }
};



// WEBPACK FOOTER //
// ./frontend/src/js/utils/sh-polyfills.js